import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for D5M1 (採購單核准沖銷)
// ============================================================

export interface ReverseCandidate {
  fd110_01: string; // 採購單號
  fd110_11: string; // 採購日期 (YYYY-MM-DD)
  fd110_12: string; // 供應商代碼
  fd110_17: string; // 業務員
  fd110_18: string; // 採購人員
  fd110_19: string; // 幣別
  fd110_20: string; // 匯率
  fd110_23: string; // 採購金額
  fd110_32: string; // 部門
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const d5m1Api = {
  /** Query purchase order candidates eligible for reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/d5m1/candidates', { params });
    return res.data;
  },

  /** Execute batch reversal for selected purchase orders */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/d5m1/reverse', { items });
    return res.data;
  },
};
